import { useI18n } from 'vue-i18n'
import useBlProviders from '@/composables/providers/useBlProvider'
import CropsDt from '@/services/dataTransferModules/cropsDt'

const cropsDt = new CropsDt()

export default function useCrops() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: crops,
		getEntities: getCrops,

		basedEntities: baseCrops,
		getBasedEntities: getBasedCrops,

		extendedEntities: extendedCrops,
		getExtendedEntities: getExtendedCrops,

		entityPreview: cropPreview,
		getEntityPreview: getCropPreview,

		entityPopup: cropPopup,
		getEntityPopup: getCropPopup,

		entity: crop,
		getEntity: getCrop,

		createEntity: createCrop,
		patchEntity: updateCrop,
		updateEntity: fullUpdateCrop,
		deleteEntity: deleteCrop,
	} = useBlProviders(cropsDt, {
		getAllMethodName: 'getFilteredCrops',
		getAllBasedMethodName: 'getFilteredBasedCrops',
		getAllExtendedMethodName: 'getFilteredExtendedCrops',

		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error while loading agri cultures'),

		showErrorNotificationForLoadingOneEntity: true,

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Couldn`t add a new crop. Please contact technical support team.'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Crop editing error'),

		showErrorNotificationForDeletingEntity: true,
	})

	return {
		flags,
		crop,
		crops,
		cropPopup,
		cropPreview,
		baseCrops,
		extendedCrops,

		getCrops,
		getBasedCrops,
		getExtendedCrops,
		getCropPreview,
		getCropPopup,
		getCrop,
		createCrop,
		updateCrop,
		fullUpdateCrop,
		deleteCrop,
	}
}
